import React from 'react';
import { Box, Typography } from '@mui/material';

export default function StatCard({ title, value, icon: Icon, color = '#6C63FF' }) {
  return (
    <Box
      sx={{
        backgroundColor: '#232636',
        border: '1px solid #2E3247',
        borderLeft: `4px solid ${color}`,
        borderRadius: 2,
        p: 1.8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: 140,
      }}
    >
      <Box>
        <Typography variant="body2" sx={{ color: '#94A3B8', mb: 0.5, fontSize: '0.8rem' }}>
          {title}
        </Typography>
        <Typography variant="h5" sx={{ color: '#F1F5F9', fontWeight: 700, fontSize: '1.4rem' }}>
          {value}
        </Typography>
      </Box>
      {Icon && (
        <Box sx={{ opacity: 0.3 }}>
          <Icon size={40} color={color} />
        </Box>
      )}
    </Box>
  );
}
